var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Grid } from "@vividtheory/minerva-lab";
import { mergeSx } from "@vividtheory/minerva-lab/system";
import React from "react";
export const breakpointSwapperClasses = {
    desktop: "BigGeoBreakpointSwapper-desktop",
    mobile: "BigGeoBreakpointSwapper-mobile",
};
/**
 * @ComponentTags - swap-mobile, swap-desktop, show, breakpoint
 */
export const BreakpointSwapper = (_a) => {
    var { breakpoint = "md", desktop, mobile, display = "revert", sx } = _a, props = __rest(_a, ["breakpoint", "desktop", "mobile", "display", "sx"]);
    return (React.createElement(React.Fragment, null,
        mobile ? (React.createElement(Grid, Object.assign({}, props, { sx: mergeSx({
                display: "none",
                breakpoints: {
                    [breakpoint]: {
                        display: display,
                    },
                },
            }, sx) }), desktop)) : (React.createElement(Grid, Object.assign({}, props), desktop)),
        desktop ? (React.createElement(Grid, Object.assign({}, props, { sx: mergeSx({
                breakpoints: {
                    [breakpoint]: {
                        display: "none",
                    },
                },
            }, sx) }), mobile)) : (React.createElement(Grid, Object.assign({}, props), mobile))));
};
//# sourceMappingURL=BreakpointSwapper.js.map